import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/admin/Admin";
import LocalStorageService from "./ports/localStorage/localStorageService";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import NotFound from "./pages/404";
import Configuration from "./pages/admin/Configuration";
import Login from "./pages/admin/Login";
import AdminDNI from "./pages/admin/AdminDNI";
import AdminPass from "./pages/admin/AdminPass";
import Mantenimiento from "./pages/Mantenimiento";
import BackendConnectionService from "./ports/backend/backendConnectionService";
import Support from "./pages/admin/Support";
import Loading from "./pages/Loading";
import Error from "./pages/Error";

export default class App extends React.Component {
    constructor(props) {
        super(props);
        if(LocalStorageService.isFirstSetup()) {
            LocalStorageService.doFirstSetup();
        }
        this.state = {
            mantenimiento: false,
            loading: true,
            error: false
        }
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
        BackendConnectionService.getInstanceConfiguration().then((response) => {
            LocalStorageService.setInstanceConfiguration(response.data);
            document.documentElement.style.setProperty('--main-color', response.data.color);
            document.documentElement.style.setProperty('--main-color-bold', response.data.colorBold);
            this.setState({
                mantenimiento: response.data.globalMaintenance
            });
        }).catch((err) => {
            console.log(err);
            this.setState({
                error: true
            });
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    }

  render() {
    const { loading, mantenimiento, error } = this.state;
    if (loading) {
        return <Loading />;
    }
    if (error) {
        return <Error />;
    }
    if (mantenimiento) {
        return <Mantenimiento />
    }
    return (
        <div className="App">
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick={true}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="admin" element={<Admin />} />
                <Route path="admin/config" element={<Configuration />} />
                <Route path="admin/dni" element={<AdminDNI />} />
                <Route path="admin/pasaporte" element={<AdminPass />} />
                <Route path="admin/soporte" element={<Support />} />
                <Route path="admin/inactive" element={<Login error={"Se ha cerrado sesión por inactividad."}/>}/>
                <Route path="*" element={<NotFound />}/>
            </Routes>
        </div>
    );
  }
}
